export function isNotNullOrUndefined<TValue>(value: TValue | null | undefined): value is TValue {
    return value !== null && value !== undefined
}

export function isNullOrUndefined<TValue>(value: TValue | null | undefined): value is null | undefined {
    return value === null || value === undefined
}

export function isKeyOf<T extends string>(key: string, object: Record<T, unknown>): key is T {
    return key in object
}

export function isBooleanMap(value: unknown): value is { [key: string]: boolean } {
    return typeof value === 'object' && value !== null && Object.values(value).every((v) => typeof v === 'boolean')
}
